<template>
  <ListingSettingsCard
    id="pd-listing-settings"
    :tour-types="propertyStore.property"
    :identity-verification="propertyStore.property?.identityVerificationEnabled ?? false"
    :screening-sensitivity="propertyStore.property?.renterRequirements?.screeningSensitivity"
    @edit-tours="tourOptionsModalRef?.open()"
    @edit-screening="screeningSensitivityModalRef?.modalRef?.show()"
  >
    <PropertyScreeningSensitivityModal ref="screeningSensitivityModalRef" />
    <PropertyTourOptionsModal ref="tourOptionsModalRef" />
  </ListingSettingsCard>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { ListingSettingsCard, usePropertyStore } from '@tallo/investor/property';

import PropertyScreeningSensitivityModal from '../../components/property-screening-sensitivity-modal.vue';
import PropertyTourOptionsModal from '../../components/property-tour-options-modal.vue';

const propertyStore = usePropertyStore();
const screeningSensitivityModalRef = ref<InstanceType<typeof PropertyScreeningSensitivityModal>>();
const tourOptionsModalRef = ref<InstanceType<typeof PropertyTourOptionsModal>>();
</script>
